
import React from 'react'
import JobInterviewContext from '../../../contexts/JobInterviewContext'
import { TemplateRow } from '../templaterow/TemplateRow'
import {Nav} from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

import { ArrowBack } from "@mui/icons-material"
import 'bootstrap/dist/css/bootstrap.min.css'
import StatusContext from '../../../contexts/StatusContext'
import AuthContext from '../../../contexts/AuthContext'
import { SaveChat } from '../savechat/SaveChat'
import {PushButton} from '../pushbutton/PushButton'
import CircularProgress from '@mui/material/CircularProgress';
import {LoginDialog} from '../logindialog/LoginDialog'

import "./navbarjobinterview.css"

export const NavBarJobInterview = ({ title })=> {
  

  
  let {
    chatName,
    setChatName,
    setChatNames,
    chatNames,
    deleteChat, 
    displayChat,
    onSave,
    uberTopics,
    expanded, 
    setExpanded,
    
} = React.useContext(JobInterviewContext);

let {
  isLoading, 
  statusNavbar,
  setStatusNavbar,
  changeLanguage,
  getChats,
  setShowLoginDialog,

} = React.useContext(StatusContext);

const {
  checkCurrentUser,
} = React.useContext(AuthContext);

 
const handleonArrowClick = () => {
  console.log("HandleOnArrowClick")
  setExpanded(!expanded)

}

const handleonClickNavBar = async () => {
  
  setStatusNavbar("");

  if (checkCurrentUser() === false)
    {
        setShowLoginDialog(true)
        return;
    }

  try
  {
    let chatsstatus = await getChats('jobinterview')
     
    if (chatsstatus !== null)
      setChatNames(chatsstatus.chats)
    setExpanded(!expanded)
   
  }
  catch  {
    console.log("HandelOnNavBarClick error")

  }
}

const handleSelect = () => {
  
  setExpanded(!expanded)
}

const onTemplateNameChange = (e) => {
  setChatName(e.target.value)
  if (e.target.value.length)
    setStatusNavbar("");
}

  return (
    
    <Navbar expanded={expanded} key={false} bg="" expand={false} className="mb-2 py-0" sticky=''>
      
        {
          isLoading &&
            <div className='wait-icon'>
                <CircularProgress style={{ color: 'white' }}/>
            </div>
        }
        <div>
        <label className="navbarTitle"> {title}</label>
        <label className="navbarTemplateName"> {chatName} </label>
        </div>

        <div style = {{marginRight: '10px'}}>
          <PushButton onClick={handleonClickNavBar} label =  {changeLanguage('common','navbartopic')}/>
        </div>
      
       
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-false`}
          aria-labelledby={`offcanvasNavbarLabel-expand-false`}
          placement="end"
        
        >
          <Offcanvas.Header  onClick={handleSelect} >
            <Offcanvas.Title  id={`offcanvasNavbarLabel-expand-false`}>
            <ArrowBack   className="styleIconWithBackground" onClick = {handleonArrowClick} />
            
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body >
            <Nav className="justify-content-end flex-grow-1 pe-3">
            <label className="navbarTemplatesTitle">{changeLanguage('assistant', 'navbarsavedtitles')}</label>
            <div className="navbarContainer" >
            
                <ul className="navbarNames">
                    {
                        Array.isArray(chatNames) && 
                            chatNames.map((chat) => (
                                <TemplateRow key= {chat.id} chat={chat} deleteHandler={deleteChat} clickHandler={displayChat} setExpand = {handleSelect} setTemplateName = {setChatName}/>
                            ))
                    }
                </ul>    
              </div>
          

              <br></br>
              <SaveChat label="Topic name" text={chatName} disabled={ (uberTopics.some(arr => arr.length > 0)) } onChange={onTemplateNameChange} onSave={onSave}/>

              {
                (statusNavbar) &&
                  <div className='statusLabel'><label>{statusNavbar}</label></div>
              }
              <br></br>

             
                <div className='navbarFonts'>
                        
                        {changeLanguage('jobinterview', 'navbartext1')}
                        <br></br>
                        <br></br>
                        
                        {changeLanguage('jobinterview', 'navbartext2')}
                        <br></br>
                        <br></br>
                        {changeLanguage('jobinterview', 'navbartext3')}
                        <br></br>
                        <br></br>
                     
                </div>     
            </Nav>
          
             <LoginDialog />
          </Offcanvas.Body>
        </Navbar.Offcanvas>
    
    </Navbar>
    
  );

}

export default NavBarJobInterview;